//请自行添加语言资源
const toxinSituation = {
  toxinSampleNo:'毒素采样码',
  qcNo:'取样单号',
  plantName:'基地',
  appointmentNo: '预约单号',
  toxinVomitoxin:'呕吐毒素',
  toxinZearalenon:'赤霉烯酮',
  toxinAflatoxin:'黄曲毒',
  toxinResult:'毒素结果',
  toxinInspectStatusName: '毒素检测状态',
  sampleTimeEnd:'毒素检测日期',
  grainAddressDetail:'粮源地',
  supplierName:'供应商',
  toxinExemptFlag: '毒素是否免检',
  sampleTimeEndTime: '毒素检测时间',
  unpeelWeighValue: '毛重',
  peelWeighValue: '皮重',
  netWeightValue: '净重',
  vehicleInPlantTime: '车辆进厂日期'
};
export default toxinSituation



// WEBPACK FOOTER //
// ./src/page/report/toxinSituation/lang/toxinSituation.zh.js